import { useEffect, useState } from "react";
import api, { formatApiError, money } from "@/lib/api";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";

const fmtDate = (d) => (d ? new Date(d).toLocaleString() : "—");

const TYPE_LABEL = {
  cash_payment: "Cash payment",
  call_limit_purchase: "Call-limit purchase",
  adjustment: "Adjustment",
  renewal_charge: "Renewal charge",
  refund: "Refund",
};

// Read-only billing/transaction history for the caller's own account.
export function TransactionHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/billing/transactions");
        setRows(data || []);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="rounded-xl border border-border bg-card card-shadow overflow-hidden" data-testid="transactions-table">
      <div className="px-5 py-3.5 border-b border-border">
        <h3 className="font-semibold text-base">Transaction History</h3>
        <p className="text-sm text-muted-foreground">Every movement on your cash balance.</p>
      </div>
      {loading ? (
        <div className="p-5 text-sm text-muted-foreground">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="p-8 text-center text-sm text-muted-foreground" data-testid="transactions-empty">
          No transactions yet.
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Description</TableHead>
              <TableHead className="text-right">Amount</TableHead>
              <TableHead className="text-right">Balance after</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((t) => {
              const credit = t.amount_minor >= 0;
              return (
                <TableRow key={t.id} data-testid={`transaction-row-${t.id}`}>
                  <TableCell className="text-muted-foreground text-sm">{fmtDate(t.created_at)}</TableCell>
                  <TableCell className="text-sm">{TYPE_LABEL[t.txn_type] || t.txn_type}</TableCell>
                  <TableCell className="text-sm text-muted-foreground max-w-[260px] truncate">{t.description || "—"}</TableCell>
                  <TableCell className={`text-right tabular-nums font-semibold ${credit ? "text-[hsl(var(--success))]" : "text-destructive"}`}>
                    {credit ? "+" : "−"}{money(Math.abs(t.amount_minor))}
                  </TableCell>
                  <TableCell className="text-right tabular-nums">{money(t.balance_after_minor)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
